import { render } from "./CloseView.vue?vue&type=template&id=89c2cbcc"
const script = {}

import exportComponent from "/Users/numgamer/Work/Job/price/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__